<!-- Start Card  -->
<div class="booked-vehicle-card">

  <!-- make/model/year -->
  <div *ngIf="MakeModelYearSearch">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-12 car">
        <div class="car-image mb-3">
          <img class="img-fluid" [src]="attachmentService.getMMYCarImageLink(vehicle.modelID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.MMYImage,vehicle.makeID,vehicle.modelID,vehicle.year)" [alt]="vehicle.vehicleName">
        </div>

         <!-- <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
          <div class="car-details d-flex justify-content-between">
            <div class="car-rank"><span class="badge badge-pill badge-primary">
                {{vehicle.vehicleRankNumber}}{{vehicle.evaluationSummary.average}}</span>
              {{vehicle.vehicleRankText}} {{vehicle.evaluationSummary.resourceName}}</div>
            <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
            </div>
          </div>
        </button> -->
      </div>
      <div class="col-lg-6  col-md-8 col-12 feature border-right">

        <div class="d-flex">
          <div class="vehicle-name mr-auto">
            {{vehicle.vehicleName}}
            {{vehicle.makeModelYearName}}
          </div>
          <div class="vehicle-top-list  d-flex align-items-top">
            <div class="vehicle-class">
              {{vehicle.vehicleClass}}
            </div>
          </div>
        </div>

        <div class="vehicle-features">
          <div class="row mt-2">
            <!-- vehicle Gear Type-->
            <div class="col-md-4 col-4 d-flex  align-items-top">
              <span>

                <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />

              </span>

              <div>
                <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                  <li>{{gearType}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Petrol Type -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                  [icon]="faGasPump"></fa-icon>
              </span>
              <div>
                <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                  <li>{{petrolType}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Passengers Number -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave"
                  [icon]="faUser"></fa-icon>
              </span>
              <div>
                <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                  <li>{{passengersNumber}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Doors Number -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                  <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
              </span>
              <div>
                <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                  <li>{{doorsNumber}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Storage -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <mat-icon placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"
                  class="fa-s luggage mr-1">luggage</mat-icon>
              </span>
              <div>
                <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                  <li>{{storage}}</li>
                </ul>
              </div>
            </div>
            <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
              <div class="car-colors  justify-content-center">
                <div class="d-flex">
                  <div class="d-flex" style="float: left;" *ngFor="let color of vehicle.vehicleColors; let i = index">
                    <span *ngIf="i < 4">
                      <span class="color-box mr-1 d-flex" [style.backgroundColor]="color.ExtericColor "></span>
                    </span>
                  </div>
                  <div  *ngFor="let color of vehicle.vehicleColors; let i = index">
                    <span *ngIf="i == 4 && vehicle.vehicleColors.length > 4">
                      <a class="" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample"><i class="far fa-plus-square color-expand"></i></a>
                    </span>
                  </div>
                </div>

                <div class="collapse" id="collapseExample">
                  <ul>
                    <li class="d-inline" *ngFor="let color of vehicle.vehicleColors; let i = index">

                      <div *ngIf="i > 4">
                        <div class="color-box mr-1" [style.backgroundColor]="color.ExtericColor "></div>
                      </div>

                    </li>
                  </ul>
                </div>

              </div>
            </div>

          </div>
          <div class="row mb-2 mt-2">
            <div class="col-md-12 d-flex align-items-top">
              <fa-icon class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}
            </div>
          </div>
          <div *ngIf="vehicle.hasPromotion;">
            <div class="promotion-box  mb-3">
              <div class="promotion-icon d-flex align-items-center">
                <fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:
              </div>
              <ul class="mb-0">
                <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
              </ul>
            </div>
          </div>

          <policies-icons [policyRequestModel]="vehicle"></policies-icons>

        </div>
      </div>
      <div class="price justify-content-center d-flex align-items-center col-lg-3 col-md-12 col-12">
        <div class="justify-content-center">
          <div class="price-container mt-2">
            <div class="duration">{{ 'PriceFor' | translate }} {{vehicle.durationUnitName | translate}}</div>
            <div class="vehicle-price">{{vehicle.vehiclePrice | number : '1.2-2'}} {{currency}}</div>
          </div>


          <div class="payable-now" *ngIf="pageType==4">

        <!--     <div *ngIf="viewBooking.paid==0">
              <div class="tilte"> {{ 'FullyPaid' | translate }} </div>

            </div> -->

            <div *ngIf="viewBooking.paid>=0">
              <div class="tilte"> {{ 'OutstandingBalance' | translate }} </div>
              <div class="text"> {{viewBooking.outStandingBalance | number : '1.2-2'}} {{currency}} </div>
            </div>

            <div *ngIf="viewBooking.paid<0">
              <div class="tilte"> {{ 'OutstandingBalance' | translate }} </div>
              <div class="text"> {{viewBooking.outStandingBalance | number : '1.2-2'}} {{currency}} </div>
            </div>

          </div>


          <!-- <div class="book-now" *ngIf="pageType!=vehicleCardEnum.ViewBooking && (stepIndex!=2&&stepIndex!=0)">
            <button *ngIf="pageType==vehicleCardEnum.Booking" (click)="bookNow()" class="btn btn-book-now"
              mat-button>{{ 'BookNowButton' | translate }}</button>
            <button *ngIf="pageType!=vehicleCardEnum.Booking" (click)="bookNow()" class="btn btn-book-now"
              mat-button>{{ 'BookNowButton' | translate }}</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- make/model/year -->
  <!-- vehicle -->
  <div *ngIf="vehicleSearch">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-12 car">
        <div class="car-image mb-3">
          <img class="img-fluid" [src]="attachmentService
          .getImageLink(vehicle.vehicleID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage)"  [alt]="vehicle.vehicleName">
        </div>

         <!-- <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
          <div class="car-details d-flex justify-content-between">
            <div class="car-rank"><span class="badge badge-pill badge-primary">
                {{vehicle.vehicleRankNumber}}{{vehicle.evaluationSummary.average}}</span>
              {{vehicle.vehicleRankText}} {{vehicle.evaluationSummary.resourceName}}</div>
            <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
            </div>
          </div>
        </button> -->
      </div>
      <div class="col-lg-6  col-md-8 col-12 feature border-right">
        <div class="d-flex">
          <div class="vehicle-name mr-auto">
            {{vehicle.vehicleName}}
            {{vehicle.makeModelYearName}}
          </div>
          <div class="vehicle-top-list  d-flex align-items-top">
            <div class="vehicle-class">
              {{vehicle.vehicleClass}}
            </div>
          </div>
        </div>
        <div class="vehicle-features">
          <div class="row mt-2">
            <!-- vehicle Gear Type-->
            <div class="col-md-4 col-4 d-flex  align-items-top">
              <span>
                <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />
              </span>

              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.vehicleGearType}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Condition Unit  -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <mat-icon placement="bottom"  ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave" class="fa-s  mr-1">
                  ac_unit</mat-icon>
              </span>
              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.hasAirConditions?'Yes':'No'}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Petrol Type -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                  [icon]="faGasPump"></fa-icon>
              </span>
              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.vehiclePetrolType}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Passengers Number -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave"
                  [icon]="faUser"></fa-icon>
              </span>
              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.vehiclePassengersNumber}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Doors Number -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
              </span>
              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.vehicleDoorsNumber}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Storage -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <mat-icon placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"
                  class="fa-s luggage mr-1">luggage</mat-icon>
              </span>
              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.vehicleStorage}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Number -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PlateNumber' | translate }}" triggers="mouseenter:mouseleave"
                  [icon]="faCar"></fa-icon>
              </span>
              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.plateNumber}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Odometer -->
            <div class="col-md-4  col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" ngbPopover="{{ 'Odometer' | translate }}" triggers="mouseenter:mouseleave" class="mr-1"
                  [icon]="faRoad"></fa-icon>
              </span>
              <div>
                <ul class="vehicle-inner-list">
                  <li>{{vehicle.vehicleOdometer}}</li>
                </ul>
              </div>
            </div>
            <div class="col-md-4  col-4 d-flex align-items-top">
              <div class="car-colors d-flex justify-content-center">
                <ul>
                  <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                    <div *ngIf="color.ExtericColor !=null">
                      <div class="color-box mr-1" [style.background-color]="color.ExtericColor"></div>
                    </div>
                    <div *ngIf=" color.ExtericColor ==null">
                      <div class="color-box mr-1" [style.background-color]="color"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
          <div class="row mb-2 mt-2">
            <div class="col-md-12 d-flex align-items-top">
              <fa-icon placement="bottom" ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s"
                [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}
            </div>
          </div>
          <div *ngIf="vehicle.hasPromotion;">
            <div class="promotion-box  mb-3">
              <div class="promotion-icon d-flex align-items-center">
                <fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:
              </div>
              <ul class="mb-0">
                <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
              </ul>
            </div>
          </div>

          <policies-icons [policyRequestModel]="vehicle"></policies-icons>

        </div>
      </div>
      <div class="price  col-lg-3 col-md-12 col-12">

        <!-- <div class="vehicle-top-list text-right">
          <fa-icon container="body" placement="bottom" ngbPopover="{{ 'TotalRental' | translate }}" triggers="mouseenter:mouseleave"  class="mr-1 grey" [icon]="faKey"></fa-icon><span>({{vehicle.vehicleRentalNumber}})</span>
        </div> -->

      <div class="justify-content-center d-flex align-items-center">
        <div class="justify-content-center">
          <div class="price-container mt-2">
            <div class="duration">{{ 'PriceFor' | translate }} {{vehicle.durationUnitName | translate}}</div>
            <div class="vehicle-price">{{vehicle.vehiclePrice | number : '1.2-2'}} {{currency}}</div>
          </div>
          <div class="payable-now" *ngIf="pageType==4">
              <div >
                <div class="tilte"> {{ 'OutstandingBalance' | translate }} </div>
                <div class="text"> {{viewBooking.outStandingBalance | number : '1.2-2'}} {{currency}} </div>
              </div>
          </div>

         <!-- <div class="book-now" *ngIf="pageType!=vehicleCardEnum.ViewBooking && stepIndex!=2">
            <button *ngIf="pageType==vehicleCardEnum.Booking" (click)="bookNow()" class="btn btn-book-now"
              mat-button>{{ 'BookNowButton' | translate }}</button>
            <button *ngIf="pageType!=vehicleCardEnum.Booking" (click)="bookNow()" class="btn btn-book-now"
              mat-button>{{ 'BookNowButton' | translate }}</button>
          </div>-->
        </div>
      </div>

      </div>
    </div>
  </div>
  <!-- vehicle -->
  <!-- class -->
  <div *ngIf="classSearch">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-12 car">
        <div class="car-image mb-3">
          <img class="img-fluid"
          #VehicleClassImg

          [src]="attachmentService
          .getImageLink(vehicle.classID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.VehicleClassImg)"
           [alt]="vehicle.vehicleName"><!--  -->
        </div>


        <!-- <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
          <div class="car-details d-flex justify-content-between">
            <div class="car-rank"><span class="badge badge-pill badge-primary">
                {{vehicle.vehicleRankNumber}}{{vehicle.evaluationSummary.average}}</span>
              {{vehicle.vehicleRankText}} {{vehicle.evaluationSummary.resourceName}}</div>
            <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
            </div>
          </div>
        </button> -->


      </div>
      <div class="col-lg-6  col-md-8 col-12 feature border-right">



        <div class="vehicle-class">
          {{vehicle.vehicleClass}}
        </div>

        <div class="vehicle-features">
          <div class="row mt-2">
            <!-- vehicle Gear Type-->
            <div class="col-md-4 col-4 d-flex  align-items-top">
              <span>
                <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />
              </span>

              <div>
                <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                  <li>{{gearType}}</li>
                </ul>
              </div>
            </div>



            <!-- vehicle Petrol Type -->
            <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                  [icon]="faGasPump"></fa-icon>
              </span>
              <div>
                <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                  <li>{{petrolType}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Passengers Number -->
            <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
              <span>
                <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave"
                  [icon]="faUser"></fa-icon>
              </span>
              <div>
                <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                  <li>{{passengersNumber}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Doors Number -->
            <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
              <span>
                <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
              </span>
              <div>
                <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                  <li>{{doorsNumber}}</li>
                </ul>
              </div>
            </div>

            <!-- vehicle Storage -->
            <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
              <span>
                <mat-icon placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"
                  class="fa-s luggage mr-1">luggage</mat-icon>
              </span>
              <div>
                <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                  <li>{{storage}}</li>
                </ul>
              </div>
            </div>
            <!-- <div class="col-md-4  col-4 d-flex align-items-top">
              <div class="car-colors d-flex justify-content-center">
                <ul>
                  <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                    <div *ngIf="color.ExtericColor !=null">
                      <div class="color-box mr-1" [style.background-color]="color.ExtericColor"></div>
                    </div>
                    <div *ngIf=" color.ExtericColor ==null">
                      <div class="color-box mr-1" [style.background-color]="color"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          -->

          </div>
          <div class="row mb-2 mt-2">
            <div class="col-md-12 d-flex align-items-top">
              <fa-icon class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}
            </div>
          </div>
          <div *ngIf="vehicle.hasPromotion;">
            <div class="promotion-box  mb-3">
              <div class="promotion-icon d-flex align-items-center">
                <fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:
              </div>
              <ul class="mb-0">
                <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
              </ul>
            </div>
          </div>

          <policies-icons [policyRequestModel]="vehicle"></policies-icons>

        </div>
      </div>
      <div class="price justify-content-center d-flex align-items-center col-lg-3 col-md-12 col-12">
        <div class="justify-content-center">
          <div class="price-container mt-2">
            <div class="duration">{{ 'PriceFor' | translate }} {{vehicle.durationUnitName | translate}}</div>
            <div class="vehicle-price">{{vehicle.vehiclePrice | number : '1.2-2'}} {{currency}}</div>
          </div>
          <div class="payable-now" *ngIf="pageType==4">

    <!--         <div *ngIf="viewBooking.paid==0">
              <div class="tilte"> {{ 'FullyPaid' | translate }} </div>

            </div> -->

            <div *ngIf="viewBooking.paid>=0">
              <div class="tilte"> {{ 'OutstandingBalance' | translate }} </div>
              <div class="text"> {{viewBooking.outStandingBalance | number : '1.2-2'}} {{currency}}  </div>
            </div>

            <div *ngIf="viewBooking.paid<0">
              <div class="tilte"> {{ 'OutstandingBalance' | translate }} </div>
              <div class="text"> {{viewBooking.outStandingBalance | number : '1.2-2'}} {{currency}} </div>
            </div>

          </div>

          <!-- <div class="book-now" *ngIf="pageType!=vehicleCardEnum.ViewBooking && stepIndex!=2">
            <button *ngIf="pageType==vehicleCardEnum.Booking" (click)="bookNow()" class="btn btn-book-now"
              mat-button>{{ 'BookNowButton' | translate }}</button>
            <button *ngIf="pageType!=vehicleCardEnum.Booking" (click)="bookNow()" class="btn btn-book-now"
              mat-button>{{ 'BookNowButton' | translate }}</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- class -->

</div>
<!-- End Card  -->
